import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  toolName: 'my_workflow_tool',
  toolDescription: 'Execute a workflow',
  inputSchema: JSON.stringify({
    type: 'object',
    properties: {},
    required: []
  }, null, 2),
  transportType: 'sse',
  authentication: 'none',
  bearerToken: '',
  customHeaderName: '',
  customHeaderValue: '',
  responseMode: 'wait',
  timeout: 300,
  enableCors: true,
  testInput: '{\n  "query": "test search",\n  "limit": 10\n}',
};

export default defaults;
